// CSS path
import "./styles/_vendor.scss";

// Main script path
import "./scripts/main.js";


// WEBPACK FOOTER //
// ./src/index.js